import { faPencil, faPlus } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Paper, styled, Tooltip, Typography } from '@mui/material';
import { TokenGrid, DefaultTokenGridColumnFn, ITokenGridColumnFn, ClientConfigurationContext } from '@ngt/openiddict';
import { FC, useContext } from 'react';
import { generatePath, Link } from 'react-router-dom';

const TokenColumnsFn: ITokenGridColumnFn = (clientConfiguration, applications, tokenTypes, statuses) => {
    const columns = DefaultTokenGridColumnFn(clientConfiguration, applications, tokenTypes, statuses)
        
    columns.push({
        field: 'actions',
        headerName: ' ',
        width: 70,
        renderCell: (params) => (
            <IconButton component={Link} to={generatePath(clientConfiguration?.administrationUris?.token ?? '/', { id: params.row.id })} color="secondary">
                <FontAwesomeIcon icon={faPencil} size="sm" />
            </IconButton>
        )
    })

    return columns;
}

const Title = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center'
}));

const ButtonBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    marginLeft: 'auto',
    marginRight: theme.spacing(2)
}));

const Tokens: FC = () => {
    const { data: clientConfiguration } = useContext(ClientConfigurationContext);

    return (
        <>
            <Title 
                variant="h1" 
                gutterBottom
            >
                Tokens
                <Tooltip title="New Token">
                    <ButtonBox>
                        <IconButton component={Link} to={generatePath(clientConfiguration?.administrationUris?.token ?? '/', { id: 'insert' })}>
                            <FontAwesomeIcon icon={faPlus} />
                        </IconButton>
                    </ButtonBox>
                </Tooltip>
            </Title>
            <Paper
                sx={{ 
                    height: 'calc(100vh - 178px)',
                    minHeight: '300px'
                }}
            >
                <TokenGrid 
                    columnFn={TokenColumnsFn} 
                />
            </Paper>
        </>
    );
}

export default Tokens;